import {Command} from "./Command";
import cmpConfig from "../../cmp-config";
import {TCData} from "../model/t-c-data";
import cmp from "../../context/context";

class GetTCDataCommand extends Command {

    public execute(version: number, callback: Function, parameter?: number[]): void {

        const validVendors:boolean  = (parameter == null || parameter == undefined || (Array.isArray(parameter) && parameter.every((item:any) => {return Number.isInteger(item);})));

        let vendorIds:number[] = [];
        if (!cmpConfig.gdprApplies) {
            vendorIds = [];
        } else if (!parameter || parameter.length == 0) {
            vendorIds = cmp().vendorList?.vendorIds()??[];
        } else {
            vendorIds = validVendors && parameter ? parameter : [];
        }

        const tcData:TCData = TCData.build(vendorIds);

        callback(tcData, validVendors);
    }
}

export {GetTCDataCommand};
